import { render, staticRenderFns } from "./ProcessAnfrageHeader.vue?vue&type=template&id=abe22020&"
import script from "./ProcessAnfrageHeader.vue?vue&type=script&lang=js&"
export * from "./ProcessAnfrageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports